import {RoutesEnum} from "@dropDesk/domain/entities/routes/routes_enum";
import History from "@dropDesk/presentation/routes/history";
import {NavigateOptions} from "react-router-dom";

export const navigate = (route: RoutesEnum, navigateOptions?: NavigateOptions) => {
    if (History.navigate) {
        History.navigate(route, navigateOptions ?? {replace: true});
    }
}
